import { TextBlock } from '../types/TextBlock';
import { RowBlock } from '../types/RowBlock';
import { ColumnBlock } from '../types/ColumnBlock';
import { HeadingBlock } from '../types/HeadingBlock';
import { CheckboxBlock } from '../types/CheckboxBlock';
import { BulletBlock } from '../types/BulletBlock';
import { NumberBlock } from '../types/NumberBlock';
import { CalloutBlock } from '../types/CalloutBlock';
import { ChoiceBlock } from '../types/ChoiceBlock';
import { ChoicePathBlock } from '../types/ChoicePathBlock';
import { DividerBlock } from '../types/DividerBlock';
import { TableBlock } from '../types/TableBlock';
import { ToggleBlock } from '../types/ToggleBlock';
import { CodeBlock } from '../types/CodeBlock';
import { ImageBlock } from '../types/ImageBlock';
import { VideoBlock } from '../types/VideoBlock';
import { VariablesBlock } from '../types/VariablesBlock';
import { LinkedVariableRowBlock } from '../types/LinkedVariableRowBlock';
import { SnippetBlock } from '../types/SnippetBlock';
import { FileUploadBlock } from '../types/FileUploadBlock';

export const blockComponents = {
  text: TextBlock,
  row: RowBlock,
  column: ColumnBlock,
  heading: HeadingBlock,
  checkbox: CheckboxBlock,
  bullet: BulletBlock,
  number: NumberBlock,
  callout: CalloutBlock,
  choice: ChoiceBlock,
  'choice-path': ChoicePathBlock,
  divider: DividerBlock,
  table: TableBlock,
  toggle: ToggleBlock,
  code: CodeBlock,
  image: ImageBlock,
  video: VideoBlock,
  variables: VariablesBlock,
  'linked-variable-row': LinkedVariableRowBlock,
  snippet: SnippetBlock,
  'file-upload': FileUploadBlock,
};
